module.exports = __webpack_public_path__ + "media/images/shadow_open-7edb620237ef7ea782615d2d8a6d7352.jpg";